import * as React from "react";
import { SVGProps } from "react";

const BankTransfer: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.9149 40H14.7521C4.64978 40 0.333496 35.6837 0.333496 25.5814V14.4186C0.333496 4.31628 4.64978 0 14.7521 0H25.9149C36.0172 0 40.3335 4.31628 40.3335 14.4186V25.5814C40.3335 35.6837 36.0172 40 25.9149 40ZM14.7521 2.7907C6.17536 2.7907 3.12419 5.84186 3.12419 14.4186V25.5814C3.12419 34.1581 6.17536 37.2093 14.7521 37.2093H25.9149C34.4916 37.2093 37.5428 34.1581 37.5428 25.5814V14.4186C37.5428 5.84186 34.4916 2.7907 25.9149 2.7907H14.7521Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M24.2587 30.4372C23.9052 30.4372 23.5517 30.307 23.2727 30.0279C22.7331 29.4884 22.7331 28.5954 23.2727 28.0558L28.9285 22.4C29.468 21.8605 30.361 21.8605 30.9006 22.4C31.4401 22.9396 31.4401 23.8326 30.9006 24.3721L25.2448 30.0279C24.9843 30.2884 24.6308 30.4372 24.2587 30.4372Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M29.9151 24.7814H10.7523C9.98949 24.7814 9.35693 24.1488 9.35693 23.3861C9.35693 22.6233 9.98949 21.9907 10.7523 21.9907H29.9337C30.6965 21.9907 31.329 22.6233 31.329 23.3861C31.329 24.1488 30.6965 24.7814 29.9151 24.7814Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M10.7522 18.0093C10.3987 18.0093 10.0452 17.8791 9.76613 17.6C9.22659 17.0605 9.22659 16.1675 9.76613 15.6279L15.4219 9.97212C15.9615 9.43259 16.8545 9.43259 17.394 9.97212C17.9336 10.5117 17.9336 11.4047 17.394 11.9442L11.7382 17.6C11.4591 17.8791 11.1057 18.0093 10.7522 18.0093Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M29.9151 18.0094L10.7522 18.0093C9.98938 18.0093 9.35693 17.3768 9.35693 16.6141C9.35693 15.8513 9.98949 15.2187 10.7523 15.2187H29.9337C30.6965 15.2187 31.329 15.8513 31.329 16.6141C31.329 17.3768 30.6965 18.0094 29.9151 18.0094Z"
      fill="#1A1C1F"
      className={props.className}
    />
  </svg>
);

export default BankTransfer;
